import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--global-blue-primary)",
      d: "M16.243 7.2h-3.6a1.6 1.6 0 0 1-1.6-1.6V2.1c-.107-.106-.705-.1-.857-.1H5.357c-.945 0-1.714.77-1.714 1.714v12.572c0 .945.77 1.714 1.714 1.714h9.286c.945 0 1.714-.77 1.714-1.714V8c0-.152-.008-.693-.114-.8"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--global-blue-secondary)",
      d: "M12.245 5.602v-3.2l3.6 3.6h-3.2a.4.4 0 0 1-.4-.4"
    }, null, -1)
  ])))
}
export default { render: render }